<template>
  <div class="flex justify-start">
    <div v-for="(slot, index) in displaySlots" :key="index" class="shrink-0 transition-transform duration-200 hover:-translate-y-[5px]">
      <div class="origin-top-left overflow-hidden">
        <Card :is-small="true" :card="slot.card" :show="slot.show" :is-extra-card="index === extraCardIndex" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Hand } from '@models/Hand';
import Card from '@/components/Card.vue';
import { computed } from 'vue';

const props = defineProps<{
  hand: Hand;
  extraCard?: boolean;
}>();

const displaySlots = computed(() => {
  const slots = [...props.hand.cardSlots];
  if (!props.extraCard && slots.length > 5) {
    slots.splice(5, 1);
  }
  return slots;
});

const extraCardIndex = props.extraCard && displaySlots.value[2].show ? 2 : 5;
</script>
